module.exports = __webpack_public_path__ + "static/media/logo-black.e8fd3156.png";